import {AfterViewInit, Component, Input, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AppStateService} from 'commons';
import {FormsModule} from '@angular/forms';
import {DacklExplicitSearchComponent} from '@datev/ngx-dackl';
import {TranslatePipe} from '@ngx-translate/core';


@Component({
    selector: 'myupdates-search-slot',
    templateUrl: './search-slot.component.html',
    styleUrls: ['./search-slot.component.scss'],
  imports: [FormsModule, DacklExplicitSearchComponent, TranslatePipe]
})
export class SearchSlotComponent implements AfterViewInit {
  @Input() whiteFocus = false;
  @ViewChild(DacklExplicitSearchComponent) dacklSearch!: DacklExplicitSearchComponent;

  constructor(private readonly router: Router,
              private readonly route: ActivatedRoute,
              readonly appState: AppStateService) { }

  ngAfterViewInit() : void {
    // dacklSearch is not finished loaded in "ngInit"
    this.route.queryParams.subscribe(params => {
       this.dacklSearch.searchString.set(params['query'] ?? '');
    });
  }

  search(): void {
    // converting from a Signal
    const searchValue= this.dacklSearch.searchString();
    if (undefined !== searchValue && searchValue.length > 0) {
      this.router.navigate(['search-result'], {queryParams: {query: searchValue}});
    }
  }

  clear(): void {
    this.dacklSearch.searchString.set('');
  }

  onSearchTermChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.dacklSearch.searchString.set(target.value);
  }

}
